import { getBookingDetailsPageLink } from 'lib/links';
import { useDetailsBooking } from 'lib/hooks/useDetailsBooking';
import { useTitleOnMount } from 'lib/hooks/useTitleOnMount';
import PageHeader from 'components/PageHeader';
import ChangeDatesRequestFlow from './ChangeDatesRequestFlow';
import { useCanRequestAmendDatesGuard } from './hooks/useCanRequestAmendDatesGuard';

const ChangeDatesRequestPage = () => {
  const { booking } = useDetailsBooking();
  useCanRequestAmendDatesGuard(booking);

  const reference = booking.reference;

  useTitleOnMount(`Date Change Request for ${reference}`);

  return (
    <>
      <PageHeader
        title="Change booking"
        bookingRef={reference}
        backLinkUrl={getBookingDetailsPageLink(booking.id)}
        backLinkTitle={'Manage your booking'}
      />
      <ChangeDatesRequestFlow />
    </>
  );
};

export default ChangeDatesRequestPage;
